import { useState } from 'react';
import { createReport, CreateReportData } from '../services/reports';
import { useCredits } from './useCredits';
import { ReportError, WebhookError } from '../utils/error';

export function useReportCreation() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { credits } = useCredits();

  const submitReport = async (data: CreateReportData) => {
    if (credits && credits < 1) {
      setError('Insufficient credits. Please purchase more credits to continue.');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const report = await createReport(data);
      return report;
    } catch (err) {
      let errorMessage: string;

      if (err instanceof ReportError) {
        errorMessage = err.message;
      } else if (err instanceof WebhookError) {
        errorMessage = 'Failed to initiate report generation. Please try again.';
      } else {
        errorMessage = 'An unexpected error occurred. Please try again.';
      }

      setError(errorMessage);
      throw new Error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return {
    submitReport,
    loading,
    error
  };
}